module.exports = __webpack_public_path__ + "static/careerDetailCubes-e74aac2faa3856f8c29ece1084ff5f7b.png";